var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift-ani"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatar}}),_c('div',{staticClass:"info-name"},[_c('div',{staticClass:"nick"},[_vm._v(_vm._s(_vm.nick))]),_c('div',{staticClass:"gift"},[_vm._v("送出 火箭X1")])]),_c('img',{staticClass:"gitf-item",attrs:{"src":require("../../../../assets/image/live/gift-item.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }